import React from 'react';

import { Modal, Button, ToastContext } from '@weezevent/nacre';

import useAppContext from '../../../../context/useAppContext';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { fetcher } from '@weezevent/weezjs-core';

export function SendMailAccountActivationModal({ open = false, redirect_uri = null, onSubmit = () => {}, onSave = () => {}, onClose = () => {}, createMode = false }) {
    const { t } = useTranslation();
    const { user } = useAuth();
    const toast = React.useContext(ToastContext);

    const [{ organization }] = useAppContext();
    const resendMailAccountActivation = React.useCallback(async () => {
        try {
            await fetcher.post(`/ticket/organizations/${organization.id}/users/${user.profile.sub}/activation_email`, {
                data: { redirect_uri: redirect_uri || window.location.href }
            });
            toast.success(t('ticket.event.sendMailAccountActivationModal.toast.success'));
        } catch {
            toast.error(t('ticket.event.sendMailAccountActivationModal.toast.error'));
        } finally {
            onClose();
        }
    }, [user, organization, onClose]);

    const email = user.profile.email || user.profile.data?.email || '';
    return (
        <Modal
            allowExternalClosing={false}
            open={open}
            onClose={onClose}
            submitButton={<Button primary label={t('ticket.event.sendMailAccountActivationModal.submitLabel')} onClick={resendMailAccountActivation} />}
            cancelButton={
                <Button
                    onClick={createMode ? onSave : onClose}
                    label={createMode ? t('ticket.event.sendMailAccountActivationModal.saveLabel') : t(`ticket.common.action.cancel`)}
                />
            }
            title={t('ticket.event.sendMailAccountActivationModal.title')}
        >
            <div style={{ marginTop: '15px' }}>{t('ticket.event.sendMailAccountActivationModal.description', { user_mail: email })}</div>
        </Modal>
    );
}
